import { render, staticRenderFns } from "./EventHeaderTabs.vue?vue&type=template&id=b5d0f594"
import script from "./EventHeaderTabs.vue?vue&type=script&lang=js"
export * from "./EventHeaderTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports